"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledForm = void 0;
var _Form = require("./Form");
// TODO: in v9, move styled() from Form.jsx to here
var StyledForm = _Form.Form;
exports.StyledForm = StyledForm;